import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout as logoutAction } from "../store/reducers/AppReducer";
import { firebaseSignOut } from "../lib/firebaseAuth";

/**
 * Provides a shared Firebase logout handler that mirrors Canary-FE behavior.
 * Ensures Firebase logout is triggered first and then clears client state.
 */
export const useMsalLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const resetClientState = useCallback(() => {
    localStorage.clear();
    dispatch(logoutAction());
    navigate("/");
  }, [dispatch, navigate]);

  const logout = useCallback(async () => {
    try {
      await firebaseSignOut();
    } catch (error) {
      console.error("Firebase logout failed:", error);
    } finally {
      resetClientState();
    }
  }, [resetClientState]);

  return { logout, resetClientState };
};

